import { Button, Stack, Typography } from '@mui/material';
import React from 'react';

export default function WarningPopup({ handleSubmit, values, loading }) {
  return (
    <Stack gap={2}>
      <Typography>
        <span style={{ fontWeight: 799 }}>Note:</span> This course is synced with Lense, so all updates are reflected
        automatically.
      </Typography>
      <Button
        variant="outlined"
        sx={{ alignSelf: 'flex-end' }}
        onClick={() => {
          handleSubmit(values);
        }}
        disabled={loading !== undefined && loading}
      >
        {loading !== undefined && loading ? 'Confirming...' : 'Confirm'}
      </Button>
    </Stack>
  );
}
